import { documentToPlainTextString } from '@contentful/rich-text-plain-text-renderer'
import { Document } from '@contentful/rich-text-types'

import JsonLd from '@ecm/ui/seo/JsonLd'

type Faq = {
  answer: string | Document
  question: string
}

type FaqJsonLdProps = {
  faq: Faq[]
}

const FaqJsonLd = ({ faq }: FaqJsonLdProps) => {
  const structuredData = {
    mainEntity: faq.map(element => ({
      '@type': 'Question',
      acceptedAnswer: {
        '@type': 'Answer',
        text:
          typeof element.answer === 'string'
            ? element.answer
            : documentToPlainTextString(element.answer),
      },
      name: element.question,
    })),
  }

  if (!faq.length) {
    return null
  }

  return <JsonLd type="FAQPage" structuredData={structuredData} />
}

export default FaqJsonLd
